import { guideSteps } from "@/mocks/manga";

export default function Guide() {
  return (
    <section id="guide" className="relative overflow-hidden bg-background-950 py-16 md:py-24">
      <div className="absolute inset-0">
        <img
          src="https://bainwo.github.io/api/search-image?query=dark%20warm%20anime%20night%20scene%20of%20a%20cozy%20apartment%20window%20with%20soft%20peach%20and%20gold%20light%20glowing%2C%20stylized%20manga%20background%2C%20deep%20charcoal%20tones%20with%20warm%20accents%2C%20cinematic%2C%20high%20quality&width=1600&height=700&seq=guide-bg-01&orientation=landscape"
          alt="泡在我家的辣妹 追更指南背景"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-background-950/80" />
      </div>

      <div className="relative mx-auto max-w-7xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-background-50/10 px-3 py-1 text-xs text-background-200 ring-1 ring-background-50/20">
            <i className="ri-compass-3-line text-sm" />
            追更指南
          </span>
          <h2 className="font-heading mt-4 text-3xl text-background-50 md:text-4xl">
            三步上手，追更泡在我家的辣妹
          </h2>
          <p className="mt-3 text-sm leading-6 text-background-200">
            从认准更新源到下载阅读，清晰路径让追更不用到处找，最新内容一次到位。
          </p>
        </div>

        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {guideSteps.map((s, i) => (
            <div
              key={s.title}
              className="rounded-lg bg-background-50/5 p-6 ring-1 ring-background-50/15 transition-colors hover:bg-background-50/10"
            >
              <div className="flex items-center justify-between">
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-accent-500 text-background-50">
                  <i className={`${s.icon} text-xl`} />
                </span>
                <span className="font-heading text-4xl text-background-50/20">
                  {String(i + 1).padStart(2, "0")}
                </span>
              </div>
              <h3 className="font-heading mt-4 text-lg text-background-50">{s.title}</h3>
              <p className="mt-2 text-sm leading-6 text-background-200">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}